import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const createFeedback = createAsyncThunk(
  "feedback/createFeedback",
  async (feedbackData, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.post("feedback", feedbackData);
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const FeedbackCreateSlice = createSlice({
  name: "FeedbackCreateSlice",
  initialState: {
    isLoading: false,
    success: false,
    data: null,
    error: null,
  },
  reducers: {
    resetCreateFeedback: (state) => {
      state.isLoading = false;
      state.success = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFeedback.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createFeedback.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload?.data;
      })
      .addCase(createFeedback.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetCreateFeedback } = FeedbackCreateSlice.actions;
export default FeedbackCreateSlice.reducer;
